// Web: replace the current history entry with the bare path, so the token leaves the address bar and
// the history without adding an entry (FR-012; data-model §10). Expo Router writes the address from
// its own state once more after the first render (and after setParams), which put `?token=` back
// (seen 2026-10-06), so the scrub repeats after those writes: on the next tasks.
function scrub(): void {
  const { history, location } = window;
  if (new URLSearchParams(location.search).has("token")) {
    history.replaceState(history.state, "", location.pathname);
  }
}

export function scrubTokenFromAddress(): void {
  scrub();
  setTimeout(scrub, 0);
  setTimeout(scrub, 100);
}
